import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { expVal } from '@atlassian/jira-feature-experiments';
import { JiraHomeWithWorkSuggestions } from './JiraHomeWithWorkSuggestions.tsx';
import { JiraHome } from './main.tsx';

export default componentWithCondition(
	() => expVal('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false),
	JiraHomeWithWorkSuggestions,
	JiraHome,
);
